import { createAsyncThunk } from "@reduxjs/toolkit";
import { CurrentUserByType, LoginResponse, LoginUser, SignupUser } from "models/User";
import { getCurrentUserAPI, loginAPI, signupAPI } from "services/api/user";
import { getSignupSource } from "hooks/useUtmTracking";

export const loginUser = createAsyncThunk<LoginResponse, LoginUser>(
  "loader/auth/login",
  async (params: LoginUser, { rejectWithValue }) => {
    try {
      const { data } = await loginAPI(params);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const signupUser = createAsyncThunk(
  "loader/auth/signup",
  async (params: SignupUser, { rejectWithValue }) => {
    try {
      const source = getSignupSource();
      const { data } = await signupAPI(params, source);

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);

export const getCurrentUser = createAsyncThunk<CurrentUserByType>(
  "loader/auth/getCurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getCurrentUserAPI();

      return data;
    } catch (error: any) {
      if (error.response.data) return rejectWithValue(error.response.data);
    }
  }
);
